import React from 'react';
import Button from 'components/ui/Button';
import Icon from 'components/AppIcon';

const ProductTable = ({ products = [], onEdit, onDeactivate, onViewSuppliers, loading = false }) => {
  const productTypeLabel = (type) => {
    const map = {
      refaccion: 'Refacción', llanta: 'Llanta', servicio: 'Servicio',
      aceite: 'Aceite', filtro: 'Filtro', bateria: 'Batería', otro: 'Otro',
    };
    return map?.[type] || type || '—';
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-16">
        <Icon name="Loader2" size={32} className="animate-spin text-muted-foreground" />
        <span className="ml-3 text-muted-foreground">Cargando productos...</span>
      </div>
    );
  }

  if (!products?.length) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-muted-foreground">
        <Icon name="Package" size={48} className="mb-3 opacity-30" />
        <p className="text-lg font-medium">Sin productos</p>
        <p className="text-sm">Agrega tu primer producto o importa un CSV</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-border bg-muted/40">
            <th className="text-left px-4 py-3 font-medium text-muted-foreground">SKU</th>
            <th className="text-left px-4 py-3 font-medium text-muted-foreground">Nombre</th>
            <th className="text-left px-4 py-3 font-medium text-muted-foreground">Marca</th>
            <th className="text-left px-4 py-3 font-medium text-muted-foreground">Categoría</th>
            <th className="text-left px-4 py-3 font-medium text-muted-foreground">Tipo</th>
            <th className="text-right px-4 py-3 font-medium text-muted-foreground">Precio Venta</th>
            <th className="text-center px-4 py-3 font-medium text-muted-foreground">Activo</th>
            <th className="text-center px-4 py-3 font-medium text-muted-foreground">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {products?.map((product) => (
            <tr key={product?.id} className="border-b border-border hover:bg-muted/20 transition-colors">
              <td className="px-4 py-3 font-mono text-xs text-muted-foreground">{product?.sku || '—'}</td>
              <td className="px-4 py-3 font-medium text-foreground max-w-[200px] truncate">{product?.name}</td>
              <td className="px-4 py-3 text-foreground">{product?.brand || '—'}</td>
              <td className="px-4 py-3 text-foreground">{product?.category || '—'}</td>
              <td className="px-4 py-3">
                <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-primary/10 text-primary">
                  {productTypeLabel(product?.productType)}
                </span>
              </td>
              <td className="px-4 py-3 text-right font-medium">
                ${parseFloat(product?.salePrice || 0)?.toLocaleString('es-MX', { minimumFractionDigits: 2 })}
              </td>
              <td className="px-4 py-3 text-center">
                <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${
                  product?.active ? 'bg-success/10 text-success' : 'bg-error/10 text-error'
                }`}>
                  {product?.active ? 'Activo' : 'Inactivo'}
                </span>
              </td>
              <td className="px-4 py-3">
                <div className="flex items-center justify-center gap-1">
                  <Button variant="ghost" size="xs" onClick={() => onEdit?.(product)} title="Editar">
                    <Icon name="Pencil" size={14} />
                  </Button>
                  <Button variant="ghost" size="xs" onClick={() => onViewSuppliers?.(product)} title="Ver Proveedores">
                    <Icon name="Building2" size={14} />
                  </Button>
                  {product?.active && (
                    <Button variant="ghost" size="xs" onClick={() => onDeactivate?.(product)} title="Desactivar">
                      <Icon name="EyeOff" size={14} className="text-error" />
                    </Button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProductTable;
